export default {
  ApplicationJsonUTF8: 'application/json; charset=utf-8',
  ApplicationJson: 'application/json',
  FormUrlEncoded: 'application/x-www-form-urlencoded',
  FormMultiPart: 'multipart/form-data',
}
